import { withStyles } from "@material-ui/core";
import { TableRow, TableCell } from "@mui/material";
import { themecolor } from "../Navigation";
export const validationFunction = (accountGroupType, typeName) => {
  let errors = {};
  if (!accountGroupType) errors.accountGroupType = true;
  if (!typeName) errors.typeName = true;
  return errors;
};

export const headers = [
  { id: 1, name: "S.NO" },
  { id: 2, name: "Name" },
  { id: 3, name: "Master Type" },
  { id: 4, name: "Legal Documents Requried" },
  { id: 5, name: "KYC Required" },
  { id: 6, name: "Transaction Enabled Without KYC" },
  { id: 7, name: "Number Configure" },
  { id: 8, name: "Action" },
];

export const accountGenerationHeader = [
  { id: 1, name: "S.NO" },
  { id: 2, name: "Prefix Name" },
  { id: 3, name: "Suffix Name" },
  { id: 4, name: "Account Groups" },
  { id: 5, name: "Edit" },
  { id: 6, name: "Status" },
  { id: 7, name: "Delete" },
];

export const TaxTypeList = [
  { id: 1, name: "TDS" },
  { id: 2, name: "INCOME_TAX" },
  { id: 3, name: "GST" },
  { id: 4, name: "TCS" },
  { id: 5, name: "OTHER" },
];

export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: `${themecolor} !important`,
    padding: "8px!important",
    color: "white !important",
    fontSize: "14px !important",
    width: "fit-content !important",
  },
  body: {
    fontSize: 13,
    fontWeight: 400,
    padding: "8px !important",
    color: "#555",
    borderBottom: "none",
  },
  p: {
    padding: "0px 10px !important",
  },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fff",
    },
  },
}))(TableRow);
